import { Injectable } from "@angular/core";
import { UserDataModel } from "../models/user-data.model";
import { StorageService } from "./storage.service";


@Injectable()
export class IdentityService {

  private static readonly COOKIE_NAME: string = 'CF_Authorization';

  constructor(
    private storageService: StorageService,
  ) { }

  /**
   * ## Identity Service Get Token Function
   * map the available cookies searching the `CF_Authorization` and extract the Jason Web Token [JWT]
   * @returns the token stored into the `CF_Authorization` cookie
   */
  public getToken(): string {
    if (this.storageService.tokenExists()) {
      return this.storageService.getSessionToken() || '';
    }

    let collection = document.cookie.split(';');
    let token: string = '';
    for (const cookie of collection) {
      const [name, content] = cookie.trim().split('=');
      if (name === IdentityService.COOKIE_NAME) {
        this.storageService.setSessionToken(content);
        token = content;
        break;
      }
    }
    return token;
  }

  /**
   * ## Identity Service Get User Function
   * return the user stored at session storage
   * @returns {UserDataModel} Object with the logged user at session storage;
   */
  public getUser(): UserDataModel | undefined {
    const user = this.storageService.getSessionUser<UserDataModel>();
    if (!user) {
      return undefined;
    }
    return user;
  }

  /**
   * ## Identity Service Set User Function
   * assign the current logged in user to session storage
   * @param user {UserDataModel} Object with user info
   */
  public setUser(user: UserDataModel): void {
    this.storageService.setSessionUser<UserDataModel>(user);
  }

  /**
   * ## Identity Service Get User Email Function
   * extract the user email from stored user at session storage
   * @returns {string} user email
   */
  public getUserEmail(): string | undefined {
    const user = this.getUser();
    if (user) {
      return user.email;
    }
    return undefined;
  }

  public getUserId(): number | undefined {
    const user = this.getUser();
    if (user) {
      return user.id;
    }
    return undefined;
  }

}
